import React, {Component} from 'react';
import {Button} from 'antd';

class UploadBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: ''
    };
  }
  componentWillReceiveProps(props) {
    this.setState({src: props.src});
  }
  selectImage = () => {
    this.refs.uploadInput.click(); //点击modal的html结构中的input标签
  }
  changeImageBeforeUpload = (e) => {
    this.props.changeImageBeforeUpload(e);
  }
  render() {
    return (
      <div className="add-blocks">
        <div className="ImagaBox" >
          <div>
            <Button onClick={this.selectImage} style={{background: '#18ade4', border: 'none', color: '#fff'}}>
              选择图片
            </Button>
            <input
              ref="uploadInput"
              type="file"
              accept="image/*"
              style={{width: '100px', border: 'none', visibility: 'hidden'}}
              onChange={this.changeImageBeforeUpload}
            />
          </div>
          <div style={{
            textAlign: 'center',
            margin: '10px 0',
            background: '#f2f2f2',
            width: '100%',
            height: '300px'
          }}
          >
            {this.state.src ?
              <img src={this.state.src} alt="" style={{maxWidth: '100%', height: '300px'}} />
              :
              null
            }
          </div>
        </div>
      </div>
    );
  }
}
export default UploadBox;



// WEBPACK FOOTER //
// ./src/components/backEnd/uploadBox.jsx